import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {AppComponent} from "../../app.component";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex} from "../../const/utils";
import {RouterLinks} from "../../enums/router-links";
import {AuthGuard} from "../../helpers/auth-guard.helper";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  submitted = false;
  global_texts: any = null;

  constructor(
    public app: AppComponent,
    private formBuilder: FormBuilder,
    private router: Router,
    private authGuard: AuthGuard
  ) {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.initializeComponentLog();
    //   }
    // });
  }

  get f() {
    return this.loginForm.controls;
  }

  ngOnInit(): void {
    this.initializeComponentLog();
  }

  initializeComponentLog() {
    this.global_texts = null;

    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;

      this.loginForm = this.formBuilder.group({
        // login: ['', [Validators.required, Validators.pattern(EmailRegex)]],
        login: ['', [Validators.required]],
        password: ['', [Validators.required]]
      });
    });
  }

  onSubmit() {
    // Display the form values
    console.log("this.loginForm.value ==> ", this.loginForm.value);
    this.submitted = true;

    // Stop here if form is invalid
    if (this.loginForm.invalid) return;

    // Call connexion method
    this.connexion(this.loginForm.value.login, this.loginForm.value.password);
  }

  connexion(_idrpps: string, _mdp: string) {
    this.app.apiService.login(_idrpps, _mdp).subscribe((resp: any) => {
      console.log("resp ==> ", resp);
      sessionStorage.setItem('role_admin', resp?.data?.user?.is_admin);
      // Save in local storage the session token and the user id
      sessionStorage.setItem('session_token', resp?.data?.token);

      // Reset the logout flag
      this.authGuard.isLogoutClicked = false;
      // Redirect to the Modules list page
      this.router.navigate([RouterLinks.ModulesList]);
    });
  }

  protected readonly RouterLinks = RouterLinks;
}
